<template>
  <span
    class="badge"
    :class="badge.class"
  >
    <i 
      class="fa mr-2"
      :class="badge.icon"
    />
    {{ badge.text }}
  </span>
</template>

<script>
export default {
  props: {
    role: {
      type: String,
      default: () => null
    },
    operatorPembantu: {
      type: Number,
      default: () => null
    },
    status: {
      type: Number,
      default: () => null
    },
    file: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      badge: {
        class: '',
        icon: '',
        text: ''
      }
    }
  },
  mounted () {
    this.getBadge()
  },
  methods: {
    getBadge () {
      // template badge, bar gak banyak nulis
      const tmp = {
          valid: { class: 'badge-success', icon: 'fa-check-circle', text: 'Valid' },
          revisi: { class: 'badge-warning', icon: 'fa-info-circle', text: 'Revisi' },
          revisiBelumProses: { class: 'badge-warning', icon: 'fa-info-circle', text: 'Revisi Belum Diproses' },
          sedangProses: { class: 'badge-warning', icon: 'fa-info-circle', text: 'Sedang Diproses' },
          belumProses: { class: 'badge-danger', icon: 'fa-info-circle', text: 'Belum Diproses' }
      }
      
      if (this.role === 'Penduduk') {
        if (this.status === 0) {
          this.badge = {
            class: 'badge-danger',
            icon: 'fa-info-circle',
            text: (this.file.file) ? 'Belum Divalidasi' : 'Belum Diupload'
          }
        // } else if (this.status > 1 && this.status < 6) {
        } else if (this.status >= 0 && this.status < 6) {
          // validasi desa
          if (this.file.is_valid_desa === 1 && this.status > 1) {
            this.badge = tmp.valid
          } else if (this.file.is_valid_desa === 2 && this.status === 3) {
            this.badge = tmp.revisi
          } else if (this.file.is_valid_desa === 3 && this.status === 3) {
            this.badge = tmp.revisiBelumProses
          } else if (this.file.is_valid_desa === 0) {
            this.badge = tmp.sedangProses
          }
        } else if (this.status > 5 && this.status < 10) {
          // validasi kecamatan
          if (this.file.is_valid_kecamatan === 1) {
            this.badge = tmp.valid
          } else if (this.file.is_valid_kecamatan === 2 && this.status === 7) {
            this.badge = tmp.revisi
          } else if (this.file.is_valid_kecamatan === 3 && this.status === 7) {
            this.badge = tmp.revisiBelumProses
          } else if (this.file.is_valid_kecamatan === 0) {
            this.badge = tmp.sedangProses
          }
        } else if (this.status > 9 && this.status <= 16) {
          // validasi dukcapil
          if (this.file.is_valid_dukcapil === 1) {
            this.badge = tmp.valid
          } else if (this.file.is_valid_dukcapil === 2 && this.status === 11) {
            this.badge = tmp.revisi
          } else if (this.file.is_valid_dukcapil === 3 && this.status === 11) {
            this.badge = tmp.revisiBelumProses
          } else if (this.file.is_valid_dukcapil === 0) {
            this.badge = tmp.sedangProses
          }
        }
      } else if (this.role === 'Operator Desa' || this.role === 'Kepala Desa') {
        if (this.status >= 5) {
          if (this.operatorPembantu) {
            if (this.status > 9 && this.status <= 16 && this.file.is_valid_dukcapil === 1) {
              this.badge = tmp.valid
            } else if (this.status === 11 && this.file.is_valid_dukcapil === 2) {
              this.badge = tmp.revisi
            } else if (this.status === 11 && this.file.is_valid_dukcapil === 3) {
              this.badge = tmp.revisiBelumProses
            } else {
              this.badge = tmp.valid
            }
          } else {
            if (this.file.is_valid_desa === 0) {
              this.badge = tmp.belumProses
            } else if (this.file.is_valid_desa === 1) {
              this.badge = tmp.valid
            } else if (this.file.is_valid_desa === 2) {
              this.badge = tmp.revisi
            } else if (this.file.is_valid_desa === 3) {
              this.badge = tmp.revisiBelumProses
            } else {
              this.badge = tmp.belumProses
            }
          }
        }
      } else if (this.role === 'Operator Kecamatan') {
        if (this.status >= 9) {
          this.badge = tmp.valid
        } else {
          if (this.file.is_valid_kecamatan === 0) {
            this.badge = tmp.belumProses
          } else if (this.file.is_valid_kecamatan === 1) {
            this.badge = tmp.valid
          } else if (this.file.is_valid_kecamatan === 2) {
            this.badge = tmp.revisi
          } else if (this.file.is_valid_kecamatan === 3) {
            this.badge = tmp.revisiBelumProses
          } else {
            this.badge = tmp.belumProses
          }
        }
      } else if (
        this.role === 'Operator Dukcapil' ||
        this.role === 'Operator Dukcapil Kecamatan' ||
        this.role === 'Admin Laksita' || 
        this.role === 'Admin Jembrana'
      ) {
        if (this.status >= 14) {
          this.badge = tmp.valid
        } else {
          if (this.file.is_valid_dukcapil === 0) {
            this.badge = tmp.belumProses
          } else if (this.file.is_valid_dukcapil === 1) {
            this.badge = tmp.valid
          } else if (this.file.is_valid_dukcapil === 2) {
            this.badge = tmp.revisi
          } else if (this.file.is_valid_dukcapil === 3) {
            this.badge = tmp.revisiBelumProses
          } else {
            this.badge = tmp.belumProses
          }
        }
      }
    }
  }
}
</script>